import { usePracticeAccess } from '@hb/react'
import { LAB_RESULTS, LabResult, USERS } from '@hb/shared'
import { collection, CollectionReference, query, where } from 'firebase/firestore'
import { useMemo } from 'react'
import { db } from '../../../backend/db'
import { useQuery } from '../useQuery'

// No orderBy — sort client-side to avoid composite index requirements.
// Queries /users/{patientId}/lab-results (matching where saveLabResult writes).
export const useAssessmentLabResults = (
  patientId: string | null | undefined,
  assessmentId: string | null | undefined,
) => {
  const { selectedPracticeId } = usePracticeAccess()
  const ref = useMemo(() => {
    if (!assessmentId) return null
    if (!patientId) return null

    const col = collection(db, USERS, patientId, LAB_RESULTS) as CollectionReference<LabResult>
    if (selectedPracticeId) {
      return query(
        col,
        where('assessmentId', '==', assessmentId),
        where('practiceId', '==', selectedPracticeId),
      )
    }
    return query(col, where('assessmentId', '==', assessmentId))
  }, [assessmentId, selectedPracticeId, patientId])
  return useQuery<LabResult>(ref)
}
